module.exports = __webpack_public_path__ + "static/media/36x36-8.cc984700.png";